import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MapBboxShapingService } from '@connect-services/client/services/map/bbox-shaping/map-bbox-shaping.service';
import { MapModal, MapModalService } from '@connect-services/client/services/map-modal.service';
import { ShapingProjectService } from '@connect-services/client/services/project/shaping/shaping-project.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule],
    selector: 'app-map-modal-shaping',
    templateUrl: './map-modal-shaping.component.html',
})
export class MapModalShapingComponent {
    protected readonly ButtonType = ButtonType;

    private readonly mapBboxShapingService = inject(MapBboxShapingService);
    private readonly mapModalService = inject(MapModalService);
    private readonly shapingProjectService = inject(ShapingProjectService);

    protected cancelArea(): void {
        this.mapModalService.close(MapModal.SHAPING, false);
        if (!this.shapingProjectService.currentState) {
            return;
        }
        this.shapingProjectService.openShapingProjectModal(this.shapingProjectService.currentState);
    }

    protected clearArea(): void {
        this.mapBboxShapingService.clearBbox();
    }

    protected validateArea(): void {
        this.mapModalService.close(MapModal.SHAPING, true);
        if (!this.shapingProjectService.currentState) {
            return;
        }
        this.shapingProjectService.openShapingProjectModal(this.shapingProjectService.currentState);
    }
}
